import { useMemo, useState } from "react";

const useSwpCalculator = () => {
    const [totalInvestment, setTotalInvestment] = useState(1000000);
    const [withdrawalPerMonth, setWithdrawalPerMonth] = useState(25000);
    const [rate, setRate] = useState(8);
    const [years, setYears] = useState(10);

    const { finalValue, totalWithdrawal } = useMemo(() => {

        const principal = Number(totalInvestment);
        const monthlyWithdrawal = Number(withdrawalPerMonth);
        const annualRate = Number(rate);
        const totalMonths = Number(years) * 12;

        if (
            principal <= 0 ||
            monthlyWithdrawal <= 0 ||
            annualRate < 0 ||
            totalMonths <= 0
        ) {
            return { finalValue: 0, totalWithdrawal: 0 };
        }


        const monthlyRate =
            Math.pow(1 + annualRate / 100, 1 / 12) - 1;

        let balance = principal;
        let withdrawn = 0;

        for (let i = 0; i < totalMonths; i++) {
            balance *= (1 + monthlyRate);

            if (balance > monthlyWithdrawal) {
                balance -= monthlyWithdrawal;
                withdrawn += monthlyWithdrawal;
            } else {
                withdrawn += balance;
                balance = 0;
                break;
            }
        }


        return {
            finalValue: Math.round(balance),
            totalWithdrawal: withdrawn,
        };
    }, [totalInvestment, withdrawalPerMonth, rate, years]);

    return {
        title: "SWP Calculator",

        inputs: [
            {
                label: "Total Investment",
                value: totalInvestment,
                setter: (val) => setTotalInvestment(Number(val)),
                min: 100000,
                max: 20000000,
                step: 10000,
            },
            {
                label: "Withdrawal Per Month",
                value: withdrawalPerMonth,
                setter: (val) => setWithdrawalPerMonth(Number(val)),
                min: 5000,
                max: 500000,
                step: 5000,
            },
            {
                label: "Expected Return Rate (p.a)",
                value: rate,
                setter: (val) => setRate(Number(val)),
                min: 4,
                max: 15,
                step: 0.5,
            },
            {
                label: "Time Period (Years)",
                value: years,
                setter: (val) => setYears(Number(val)),
                min: 1,
                max: 40,
                step: 1,
            },
        ],

        totalInvestment,
        totalWithdrawal,
        finalValue,

        infoContent: {
            heading: "SWP Calculator – Systematic Withdrawal Plan",
            description:
                "A Systematic Withdrawal Plan (SWP) allows investors to withdraw a fixed amount regularly while the remaining corpus continues to earn returns.",

            subHeading1: "How It Works",
            subContent1:
                "Withdrawal happens at the beginning of each month and the remaining balance grows at an effective monthly rate.",

            formula:
                "Monthly Balance = (Previous Balance − Withdrawal) × (1 + r_month)",

            subHeading2: "Benefits",
            benefits: [
                "Provides regular income",
                "Ideal for retirement planning",
                "Keeps remaining corpus invested",
                "Balances income and growth",
            ],
        }
    };
};

export default useSwpCalculator;